// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'slideshow-solid';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path
      fill='currentColor'
      d='M16.688 1.641H1.313a.75.75 0 0 0-.75.75v10.313c0 .414.335.75.75.75h15.374a.75.75 0 0 0 .75-.75V2.39a.75.75 0 0 0-.75-.75z'
    />
    <path d='M8.856.563V1.64M9 13.454v2.25m-2.31 1.731L9 15.703l2.307 1.73' />
  </g>
);

export const viewBox = '0 0 18 18';
